import { defineMessages } from 'react-intl';

export const dictationMessages = defineMessages({
  cleanupFailed: {
    defaultMessage: "Couldn't tidy your dictation. Your original text was kept.",
    id: 'SjLxnHxu3l',
    description:
      'Toast shown when the dictation clean-up request fails and the raw dictated text stays in the note',
  },
  cleanupInterrupted: {
    defaultMessage:
      "Couldn't finish tidying your dictation. Check the text before you continue.",
    id: 'N2fZny50Uz',
    description:
      'Toast shown when the dictation clean-up stream fails after it has started replacing the dictated text, so the note holds partly tidied text',
  },
});
